import { TranslateResult } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MessageToastMixin extends Vue {
  showSuccess(message: string | TranslateResult) {
    this.showToast('success', message as string);
  }

  showError(message: string | TranslateResult) {
    this.showToast('danger', message as string);
  }

  showToast(type: string, message: string) {
    this.$buefy.toast.open({
      message,
      type: `is-${type}`,
      position: 'is-bottom',
    });
  }
}
